<template>
  <div style="display: flex; border: 1px solid #e9ebef;" :class="[index % 2 ? 'double' : '', 'div_hover']">
    <div class="row no-gutters align-items-center transfer-item ">
      <el-checkbox class="iblock" :label="source.value || ''" :key="source.value">
        {{ '' }}
      </el-checkbox>
    </div>
    <div class="content">
      <div> {{ source.member_name }}</div>
      <div>{{ source.login_account }}</div>
      <div> {{ source.mobile }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'item-component',
  props: {
    index: {
      type: Number
    },
    source: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  display: flex;
  // background-color: #000;
  font-size: 12px;

  div {
    width: 86px;
    height: 100%;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-left: 1px solid #e9ebef;
    box-sizing: border-box;
    margin-bottom: -1px;
  }
}

.double {
  background-color: #fafafa;
}

.div_hover {
  &:hover {
    background-color: #f5f7fa;
  }
}
</style>
